module.exports = __webpack_public_path__ + "img/23 otros.7ce928b2.jpg";